import React from "react";

export interface BannerImageInfo {
  url: string;
  width: number;
}

interface BannerCaruselItemProps {
  target: string;
  imagePrefix?: string;
  images: BannerImageInfo[];
  currentWith: number;
  desc: string;
  id: number;
  needReady: boolean;
}

interface BannerCaruselItemState {
  isReady: boolean;
  bestImageSrc : string;
}

export class BannerCaruselItem extends React.Component<
  BannerCaruselItemProps,
  BannerCaruselItemState
> {
  constructor(props: BannerCaruselItemProps) {
    super(props);
    this.state = { isReady: false, bestImageSrc:"" };
  }

  componentDidUpdate(
    prevProps: BannerCaruselItemProps,
    prevState: BannerCaruselItemState
  ) {
    if (!this.state.isReady && this.props.needReady) {
      let bis = this.getBestImage();
      this.setState({ isReady: true, bestImageSrc : bis });
    }
    if(this.props.currentWith !== prevProps.currentWith){
      this.setState({ isReady: false, bestImageSrc :"" });
    }
  }

  render() {
    let leftPos = this.props.id * 100 + "%";
    return (
      <div
        className="bannercarusel item"
        style={{ position: "absolute", left: leftPos }}
      >
        {this.state.isReady ? (
          <a href={this.props.target}>
            <img
              src={this.props.imagePrefix + this.getBestImage()}
              alt={this.props.desc}
              title={this.props.desc}
              style={{ maxWidth: "100%" }}
            />
          </a>
        ) : null}
      </div>
    );
  }
  getBestImage() {
    let bestSize = Number.MAX_SAFE_INTEGER;
    let bestIndex = 0;
    this.props.images.map((item, index) => {
      let diff = this.props.currentWith - item.width;
      if (diff < 0) diff = diff * -1;
      if (diff < bestSize) {
        bestSize = diff;
        bestIndex = index;
      }
      return 0;
    });

    return this.props.images[bestIndex].url;
  }
}
